import { createContext } from 'react';
import { noop } from '../../utils/general';
export var AccordionMainContext = /*#__PURE__*/createContext({
  selectedItemId: null,
  onItemClick: noop
});
export var AccordionSubContext = /*#__PURE__*/createContext({
  id: null
});